import Head from "next/head";
import PageLayout, { siteTitle } from "@/components/PageLayout";
import Link from "next/link";
import Image from "next/image";
import ProductService from "@/lib/services/products.js";
import SearchBuilder from "@/components/search_builder.js";
import Paginator from "@/components/paginator";
import ProductTileV2 from "@/components/product_tile_v2";
import { useState, useReducer, useEffect } from "react";
import Qs from "qs";
import searchTranslator from "@/lib/search_translator.js";
import Loader from "@/components/loading_animation.js";
import stringifySearch, { loadConfig } from "@/lib/utils.js";

function DiscontinuedProductsPage(results) {
  const {
    products,
    total_count,
    initialSearch,
    page_layout,
    favicon,
    stylesheet
  } = results;
  const [isLoading, setIsLoading] = useState(false);
  const [prods, setProducts] = useState(products);
  const [totalCount, setTotalCount] = useState(total_count);

  const searchProducts = async (search, pageChange) => {
    setIsLoading((currentIsLoaded) => true);
    fetch(
      "/lex-api/discontinued_products" +
        "?" +
        Qs.stringify(search, { arrayFormat: "brackets", encode: true })
    )
      .then((res) => res.json())
      .then((data) => {
        setIsLoading((currentIsLoaded) => false);
        setProducts(data.products);
        setTotalCount(data.total_count);
      });
  };

    return (
    <PageLayout
      title="Discontinued Products"
      page_layout={page_layout}
      cart_enabled={false}
      favicon={favicon}
      stylesheet={stylesheet}
    >
      <SearchBuilder initialSearch={initialSearch} search={searchProducts}>
        {
          (searchState) => {
            return (
              <section className="lexcms-discontinued-products-page-container">
                <section className="lexcms-discontinued-products-page-header-container">
                  <div className="lexcms-discontinued-products-header">
                    <h1 className="lexcms-discontinued-products-header-text">
                      Discontinued Products
                    </h1>
                  </div>
                  <div className="lex-cms-pagination-top">
                    {totalCount > 10 && (
                      <Paginator itemsPerPage={10} pageRangeDisplayed={5} totalCount={totalCount} 
                      search={searchState} />
                    )}
                  </div>
                </section>
                <section className="lexcms-discontinued-products-page-body-container">
                  <div className="lexcms-product-tile-v2-grid-container">
                    {isLoading && <Loader />}
                    {
                      prods &&
                      prods.length > 0 &&
                      prods.map((product, i) => {
                        return (
                          <ProductTileV2
                            key={product.id}
                            product={product}
                            page={'discontinued'}
                          />
                        );
                      })
                    }
                    {prods?.length <= 0 && (
                      <div className="lexcms-no-results-found-container">
                        <div className="lexcms-no-results-found-image"></div>
                        <h2 className="lexcms-no-results-found-text">
                          No Discontinued Products currently exist.
                        </h2>
                      </div>
                    )}
                  </div>
                </section>
                <div className="lex-cms-pagination-bottom">
                  {totalCount > 10 && (
                    <Paginator itemsPerPage={10} pageRangeDisplayed={5} totalCount={totalCount} 
                    search={searchState} />
                  )}
                </div>
              </section>
            )
          }
        }
      </SearchBuilder>
    </PageLayout>
  );
}

export async function getServerSideProps(context) {
  let  token = context.req?.headers['lex-api-token'];
  let service = await ProductService.build(
    token,
    context.req?.headers.host
  );
  //get the query and build a default and merge discontinued params in case there are 
  //extra search params added in the future
  let q  = context.query
  let apiFriendlyQ = searchTranslator(q, true);
  apiFriendlyQ.q = apiFriendlyQ.q || {}
  apiFriendlyQ.q['is_discontinued_eq'] = true
  apiFriendlyQ.q['s'] = 'discontinued_date desc';
  let search = await service.index(apiFriendlyQ, {per_page: 10});

  let pageConfig = loadConfig(service);
  search.initialSearch =  searchTranslator(q);  
  return {
    props: { ...search, ...pageConfig },
  };
}

export default DiscontinuedProductsPage;
